import React, { useState } from "react";
import styles from "../styles/contact.module.css";
// Assuming global Navbar is used in App.js layout, remove Navbar import/render here

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Directly handle form submission
  const handleFormSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission
    const { name, email, subject, message } = formData;

    // Basic validation (optional, but recommended)
    if (!name || !email || !subject || !message) {
      alert("Please fill out all fields.");
      return;
    }

    const recipientEmail = "help.jobassistant@gmail.com"; // Your support email
    const mailtoSubject = encodeURIComponent(subject);
    const mailtoBody = encodeURIComponent(
      `From: ${name} (${email})\n\nMessage:\n${message}`
    );

    // Attempt 1: mailto link (works widely but less reliable for prefill on all clients)
    // const mailtoUrl = `mailto:${recipientEmail}?subject=${mailtoSubject}&body=${mailtoBody}`;
    // window.location.href = mailtoUrl;

    // Attempt 2: Open Gmail compose window (more reliable for Gmail)
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${recipientEmail}&su=${mailtoSubject}&body=${mailtoBody}`;
    window.open(gmailUrl, "_blank", "noopener,noreferrer");

    // Optional: Clear form after submission attempt
    // setFormData({ name: "", email: "", subject: "", message: "" });
    // alert("Your email client should open shortly to send the message.");
  };

  return (
    // Use consistent page container and wrapper
    <div className={styles.pageContainer}>
      <div className={styles.contentWrapper}>
        <section className={styles.contactSection}>
          <h1 className={styles.pageHeader}>Get In Touch</h1>
          <p className={styles.pageSubtitle}>
            Have questions, feedback, or need support? We're here to help!
          </p>

          <div className={styles.contactGrid}>
            {/* Contact Information Side */}
            <div className={styles.contactInfo}>
              <h2>Contact Information</h2>
              <p className={styles.infoIntro}>
                Reach out to us through the following channels:
              </p>

              <div className={styles.contactMethod}>
                <div className={styles.iconWrapper}>
                  <i className="fas fa-envelope"></i>
                </div>
                <div>
                  <h3>Email Support</h3>
                  <p>
                    Best for detailed queries:{" "}
                    <a href="mailto:help.jobassistant@gmail.com">
                      help.jobassistant@gmail.com
                    </a>
                  </p>
                  <p className={styles.responseTime}>
                    Typical Response: Within 24 business hours
                  </p>
                </div>
              </div>

              <div className={styles.contactMethod}>
                <div className={styles.iconWrapper}>
                  <i className="fas fa-phone-alt"></i>
                </div>
                <div>
                  <h3>Phone Support</h3>
                  <p>For urgent matters: +91 87507 98260</p>
                  <p className={styles.responseTime}>
                    Hours: 10 AM - 6 PM IST (Mon-Fri)
                  </p>
                </div>
              </div>

              <div className={styles.contactMethod}>
                <div className={styles.iconWrapper}>
                  <i className="fas fa-question-circle"></i>
                </div>
                <div>
                  <h3>Need Help Getting Started?</h3>
                  <p>
                    Check our <a href="/#how-it-works">How It Works</a> section
                    or visit the <a href="/login">Try Now</a> page for setup
                    instructions.
                  </p>
                </div>
              </div>
            </div>

            {/* Contact Form Side */}
            <div className={styles.contactForm}>
              <h2>Send Us a Message</h2>
              <p className={styles.formIntro}>
                Fill out the form below, and we'll get back to you via email.
              </p>
              <form onSubmit={handleFormSubmit}>
                <div className={styles.formGroup}>
                  <label htmlFor="name">Your Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="e.g., John Doe"
                    required
                    aria-required="true"
                  />
                </div>
                <div className={styles.formGroup}>
                  <label htmlFor="email">Your Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="e.g., john.doe@email.com"
                    required
                    aria-required="true"
                  />
                </div>
                <div className={styles.formGroup}>
                  <label htmlFor="subject">Subject</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="e.g., Question about Premium Plan"
                    required
                    aria-required="true"
                  />
                </div>
                <div className={styles.formGroup}>
                  <label htmlFor="message">Your Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="5" // Suggest initial height
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Please describe your query in detail..."
                    required
                    aria-required="true"
                  ></textarea>
                </div>
                <button type="submit" className={styles.submitButton}>
                  <i className="fas fa-paper-plane"></i> Open Email Client to
                  Send
                </button>
                <p className={styles.formNote}>
                  Note: Clicking sends your message details to your default
                  email client (like Gmail).
                </p>
              </form>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
